// Entry point for esbuild bundling (jsbundling-rails)
import "@hotwired/turbo-rails"
import $ from "jquery"
import "bootstrap"
import "datatables.net-dt"

// expose jQuery globally for legacy scripts/plugins
window.$ = window.jQuery = $

function initFlashMessage() {
  const $flash = $("#flash")
  if (!$flash.length) return

  const $alert = $flash.find(".alert")
  if ($alert.length === 0) return
  if ($alert.data("initialized")) return
  $alert.data("initialized", true)

  let timerId
  const hide = () => $flash.css("right", "-100%")
  const show = () => {
    $flash.css("right", "0")
    timerId = setTimeout(hide, 5000)
    $flash.find(".progress-fill")
      .css({ width: "100%" })
      .animate({ width: "0%" }, 5000, "linear")
  }

  show()

  $flash.on("mouseenter", () => clearTimeout(timerId))
  $flash.on("mouseleave", () => {
    clearTimeout(timerId)
    timerId = setTimeout(hide, 1000)
  })
}

function initBootstrapComponents() {
  $('[data-toggle="tooltip"]').tooltip()
}

function initUpdateRecordsSearch() {
  const container = document.querySelector("[data-update-records-search]")
  const addButton = document.querySelector("[data-add-update-record-filter]")
  if (!container || !addButton || addButton.dataset.initialized) return

  addButton.dataset.initialized = "true"
  addButton.addEventListener("click", () => {
    const fields = container.querySelectorAll(".field")
    const source = fields[fields.length - 1]
    if (!source) return

    const nextIndex = fields.length
    const clone = source.cloneNode(true)

    clone.querySelectorAll("select, input").forEach((input) => {
      input.name = input.name.replace(/q\[c\]\[\d+\]/, `q[c][${nextIndex}]`)
      input.id = input.id.replace(/q_c_\d+/, `q_c_${nextIndex}`)

      if (input.tagName === "INPUT") input.value = ""
      if (input.tagName === "SELECT") input.selectedIndex = 0
    })

    container.appendChild(clone)
  })
}

document.addEventListener("turbo:load", () => {
  initFlashMessage()
  initBootstrapComponents()
  initUpdateRecordsSearch()
})
document.addEventListener("turbo:render", initFlashMessage)
